import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'smarch_admin_token';

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const resolveImageUrl = (url) => {
  if (!url) return '';
  const raw = String(url).trim();
  if (!raw) return '';

  // Fast path: valid absolute URLs
  if (/^https?:\/\//i.test(raw)) return raw;

  // Recover malformed absolute URLs that were saved without domain,
  // e.g. "HTTPS:/api/files/..." or "https:/api/files/..." (single slash,
  // missing host). Strip the broken protocol prefix and treat as a
  // backend-relative path.
  const malformed = raw.match(/^https?:\/?(?!\/)(.+)$/i);
  if (malformed) {
    const rest = malformed[1].startsWith('/') ? malformed[1] : `/${malformed[1]}`;
    return `${BACKEND_URL}${rest}`;
  }

  if (raw.startsWith('/api/')) return `${BACKEND_URL}${raw}`;
  return raw;
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || 'Erreur inconnue';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .join(' ');
  }
  return String(detail);
};
